import React, { useState, useEffect } from "react";
import Loader from "../../../../components/Loader/Loader";
import PendingFilters from "./pending-filters";
import Filter from "../../../../components/Filter/Filter";
import { connect } from "react-redux";
import { pendingEvents } from "../../../../actions/admin/scheduled-event-actions";
import isEmpty from "../../../../validation/is-empty";
import { toggleFilter } from "../../../../actions/filterActions";
import { FRONTEND_BASE_URL } from "../../../../utils/utility";
import { Pagination } from "antd";
import { Row, Col, Modal, ModalBody } from "reactstrap";
import { sendPostRequest } from "../../../../actions/app-actions";
import { notification } from "../../../../utils/utility";
import PendingViewDetailsModal from "./pending-view-details-modal";
import { trackBookingLinkCopied } from "../../../../utils/productAnalytics";
import ScheduledEventCard from "./ScheduledEventCard";

const Pending = (props) => {
  const [events, setEvents] = useState([]);
  const [showDeleteEventModal, setShowDeleteEventModal] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [totalEvents, setTotalEvents] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showViewDetailModal, setShowViewDetailModal] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    showSizeChanger: false,
  });

  useEffect(() => {
    fetchListEvents({ pagination });
  }, []);

  /**
   * Copy event url
   * @param string event_url
   */
  const onCopyEventLink = (eventURL, copyFieldElementId, eventId = null) => {
    var copyText = document.getElementById(copyFieldElementId);
    copyText.disabled = false;
    copyText.select();
    document.execCommand("copy");
    copyText.disabled = true;
    window.getSelection().removeAllRanges();
    notification.success(
      `Event URL Copied ${FRONTEND_BASE_URL}adhoc-booking/${eventURL}`
    );
    trackBookingLinkCopied({ eventId, eventUrl: eventURL });
  };

  /**
   * on delete adhoc event
   */
  const onDelete = (eventId) => {
    const { sendPostRequest } = props;
    setIsLoading(true);
    sendPostRequest({
      url: `/admin/adhoc-delete`,
      data: {
        id: eventId,
      },
      onSuccess: function () {
        setIsLoading(false);
        setShowDeleteEventModal(false);
        fetchListEvents({ pagination });
        notification.success(`Event successfully deleted`);
      },
      onError: function (error) {
        console.log("error", error);
        setIsLoading(false);
      },
    });
  };

  /**
   * prepare data parameters to be send to server
   * @param {*} params
   */
  const prepareDataParam = (params) => {
    let sortField = "id";
    let sortOrder = "asc";

    if (!isEmpty(params.sortField) && !isEmpty(params.sortOrder)) {
      sortField = params.sortField;
      sortOrder = params.sortOrder === "ascend" ? "asc" : "desc";
    }

    return {
      pageSize: params.pagination.pageSize,
      pageNumber: params.pagination.current,
      sortField,
      sortOrder,
      filter: {
        ...params.filters,
      },
    };
  };

  /**
   * fetch list events
   */
  const fetchListEvents = (params = {}) => {
    setIsLoading(true);
    const { pendingEvents } = props;
    pendingEvents({
      data: prepareDataParam(params),
      onSuccess: function (response) {
        const { data, total } = response;
        setEvents(data);
        setTotalEvents(total);
        setPagination({ ...params.pagination });
        setIsLoading(false);
      },
      onError: function (error) {
        console.error(error);
        setIsLoading(false);
      },
    });
  };

  /**
   * on handle table change
   * @param {*} pagination
   * @param
   */
  const handleTableChange = (pagination, filters, sorter) => {
    fetchListEvents({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      filters,
    });
  };

  /**
   * on clear filter handler
   */
  const clearFilterHandler = () => {
    setIsLoading(true);
    handleTableChange(
      {
        ...pagination,
      },
      {},
      {}
    );
  };

  /**
   * on page change
   * @param {*} page
   * @param {*} pageSize
   */
  const onPageChange = (page, pageSize) => {
    setIsLoading(true);
    fetchListEvents({
      pagination: {
        current: page,
        pageSize: pageSize,
      },
    });
  };

  /**
   * filter records
   */
  const filterRecords = () => {
    const { toggleFilter, filter } = props;
    toggleFilter(false);
    setIsLoading(true);
    handleTableChange(
      {
        ...pagination,
      },
      {
        ...filter.searchFilters,
      },
      {}
    );
  };

  return (
    <div className="rd_pasevencontth">
      <Loader isShowLoader={isLoading} />
      <Filter
        name="Pending events"
        level="section"
        subtitle="Requests waiting for a response."
        onFilterRecords={filterRecords}
        onClearFilterHandler={clearFilterHandler}
      >
        <PendingFilters />
      </Filter>

      {(events || []).length > 0 ? (
        <div className="rd_eventcardscontainer se-pending-list">
          {(events || []).map((event, index) => {
            const { event_url, id } = event || {};
            const copyFieldId = "copy-field-element-" + index;
            const bookingLink = `${FRONTEND_BASE_URL}adhoc-booking/${event_url}`;
            return (
              <ScheduledEventCard
                key={id || index}
                event={event}
                variant="pending"
                showRole={false}
                onViewDetail={() => {
                  setEventId(id);
                  setShowViewDetailModal(true);
                }}
                extra={
                  <div className="se-pending-link">
                    <input
                      type="text"
                      id={copyFieldId}
                      value={bookingLink}
                      readOnly
                      disabled
                    />
                    <button
                      type="button"
                      onClick={() => onCopyEventLink(event_url, copyFieldId, id)}
                    >
                      Copy link
                    </button>
                  </div>
                }
                actions={
                  <button
                    type="button"
                    className="se-pending-delete"
                    onClick={() => {
                      setEventId(id);
                      setShowDeleteEventModal(true);
                    }}
                  >
                    Delete
                  </button>
                }
              />
            );
          })}
        </div>
      ) : !isLoading ? (
        <div className="se-empty">
          <strong>No pending events</strong>
          <span>Ad-hoc booking links waiting for invitees will show up here.</span>
        </div>
      ) : null}

      {showDeleteEventModal && (
        <Modal
          isOpen={showDeleteEventModal}
          toggle={() => setShowDeleteEventModal(false)}
          centered
          className="se-details-modal"
          contentClassName="se-details-modal__content"
        >
          <ModalBody>
            <div className="se-details">
              <header className="se-details__header">
                <div className="se-details__header-copy">
                  <p className="se-details__eyebrow">Delete event</p>
                  <h2>Delete this pending event?</h2>
                </div>
                <button
                  type="button"
                  className="se-details__close"
                  onClick={() => setShowDeleteEventModal(false)}
                  aria-label="Close"
                >
                  ×
                </button>
              </header>
              <p className="se-confirm__copy">
                This booking link will stop working. This cannot be undone.
              </p>
              <div className="se-details__actions">
                <button
                  type="button"
                  className="se-btn se-btn--ghost"
                  onClick={() => setShowDeleteEventModal(false)}
                >
                  Keep event
                </button>
                <button
                  type="button"
                  className="se-btn se-btn--danger"
                  onClick={() => onDelete(eventId)}
                >
                  Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}

      {showViewDetailModal && (
        <PendingViewDetailsModal
          eventId={eventId}
          showViewDetailModal={showViewDetailModal}
          handleClose={() => {
            setShowViewDetailModal(false);
          }}
        />
      )}

      {(events || []).length > 0 ? (
        <Row className="pb-4 pr-md-3 mt-3">
          <Col className="text-center" lg="12" md="12">
            <Pagination
              className="list-view-pagination"
              defaultCurrent={pagination.current}
              current={pagination.current}
              total={totalEvents}
              pageSize={pagination.pageSize}
              onChange={onPageChange}
              showSizeChanger={false}
            />
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  filter: state.filter,
});

export default connect(mapStateToProps, {
  pendingEvents,
  toggleFilter,
  sendPostRequest,
})(Pending);
